import { render, staticRenderFns } from "./DepartmentCommentsWidget.vue?vue&type=template&id=d817a652&"
import script from "./DepartmentCommentsWidget.vue?vue&type=script&lang=ts&"
export * from "./DepartmentCommentsWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports